import { GiphyFetch } from '@giphy/js-fetch-api'
import { REACT_APP_GIPHY_API_KEY } from 'env'
import { QueryKey, useInfiniteQuery } from 'react-query'

interface Props {
  query?: string
  queryKey?: QueryKey
  perPage?: number
}

interface Options {
  enabled?: boolean
}

const giphyApiClient = new GiphyFetch(REACT_APP_GIPHY_API_KEY)

export const useGiphy = (
  { perPage = 12, query, queryKey = ['useGiphy', query || 'trending'] }: Props,
  options: Options = {},
) => {
  return useInfiniteQuery(
    queryKey,
    async ({ pageParam = 1 }) => {
      if (query) {
        return await giphyApiClient.search(query, { limit: perPage, offset: (pageParam - 1) * perPage, rating: 'g' })
      }

      return await giphyApiClient.trending({ limit: perPage, offset: (pageParam - 1) * perPage, rating: 'g' })
    },
    {
      ...options,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      cacheTime: 1000 * 60 * 24,
      staleTime: Infinity,
      getNextPageParam: (lastPage) => {
        if (!lastPage?.pagination) {
          return undefined
        }

        const { total_count, count, offset } = lastPage.pagination

        if (total_count > count + offset) {
          return offset / count + 2
        }

        return undefined
      },
    },
  )
}
